export default "__VITE_ASSET__HMFmkcit__"